import React, { useState } from 'react';

import AccordionItem from '../../custom-visual-inspection/accordion-item';
import Button from '../../../themed/button';
import CustomUTMInspectionFormEditItem from '../../../forms/custom-utm/customUTMInspectionFormEditItem';
import CustomUTMInspectionReadings from './readings';
import Confirm from '../../../themed/confirm';
import Conditional from '../../../common/conditional';

import { SelectOption, UTMInspection } from '../../../../utils/models';

interface CustomUTMInspectionItemProps {
    onDeleteInspectionItem: (item: UTMInspection) => void;
    includeSize: boolean;
    initialData: UTMInspection;
    corrosionAllowance: number;
    options: SelectOption[];
    isOpenOnDefault: boolean;
    onEditInspectionItem: (updatedItem: UTMInspection) => void;
}

const CustomUTMInspectionItem: React.FC<CustomUTMInspectionItemProps> = ({ corrosionAllowance, includeSize, isOpenOnDefault, onDeleteInspectionItem, initialData, options, onEditInspectionItem }) => {
    const [editInspectionItem, setEditInspectionItem] = useState(false);
    const [deleteInspectionItem, setDeleteInspectionItem] = useState(false);

    const handleToggleEditInspectionItems = () => {
        setEditInspectionItem(prev => !prev);
    };

    const handleToggleDeleteInspectionItem = () => {
        setDeleteInspectionItem(prev => !prev);
    };

    const handleItemReadingChange = (readings: UTMInspection['items']) => {
        const updatedUTMInspection = { ...initialData, items: readings };
        onEditInspectionItem(updatedUTMInspection);
    };

    const handleItemUpdate = (updatedItem: UTMInspection) => {
        onEditInspectionItem(updatedItem);
        handleToggleEditInspectionItems();
    }

    return ( 
        <AccordionItem isActive isOpenOnDefault={isOpenOnDefault} title={initialData.sectionTitle}>
            <Conditional isVisible={deleteInspectionItem}>
                <Confirm
                    title="Confirm Delete"
                    message="Are you sure you want to delete this section? This action is not reversible!"
                    onCancel={handleToggleDeleteInspectionItem}
                    onConfirm={() => onDeleteInspectionItem(initialData)} 
                />
            </Conditional>

            <Conditional isVisible={!deleteInspectionItem}>
                <div className="d-flex justify-content-end align-items-center mb-4">
                    <Button label='Edit Start & End Columns' onClick={handleToggleEditInspectionItems} />
                    
                    <div className="ms-4">
                        <Button 
                            icon='trash' 
                            label='Delete' 
                            style={{ backgroundColor: 'red' }} 
                            onClick={handleToggleDeleteInspectionItem} 
                        />
                    </div>
                </div>
                
                {editInspectionItem ? (
                    <CustomUTMInspectionFormEditItem 
                        initialInspectionItem={initialData} 
                        onEdit={handleItemUpdate} 
                        onCancelEdit={handleToggleEditInspectionItems} 
                    />
                ) : (
                    <CustomUTMInspectionReadings
                        includeSize={includeSize}
                        options={options}
                        corrosionAllowance={corrosionAllowance} 
                        inspectionItem={initialData}
                        onReadingChange={handleItemReadingChange}
                    />
                )}
            </Conditional>
        </AccordionItem>
     );
}
 
export default CustomUTMInspectionItem;